import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import parse from 'html-react-parser';
import { Link } from 'react-router-dom'
import { Header } from '../comp/Header'
import { ShoppingCart as ShoppingCartIcon, MapPin, Clock, Award, Users, Shield, Wrench, CheckCircle } from 'lucide-react'
import { Button } from '../Components/ui/button'
import { ImageWithFallback } from '../Components/figma/ImageWithFallback'
import { CartItem, ShoppingCart } from '../comp/ShoppingCart'
import Cookies from 'js-cookie'
import { catalogClient } from '../services/grpc'
import * as pb from '../generated/catalog_pb';
import { NewHeader } from '../comp/NewHeader'
import { Footer } from '../comp/Footer';
import Logo from "../comp/icons/Logo"
interface PageData {
  Title: string;
  Descript: string;
  html: string;
  keyword: string
}
 

export function Page(){
  const { pagename = 'main' } = useParams<{ pagename?: string }>();

  const [data, setData] = useState<PageData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [isCartOpen, setIsCartOpen] = useState(false)
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [cartItems, setCartItems] = useState<CartItem[]>([]);
  const [cartItemCount, setCartItemCount]= useState(0);
  const [customerName, setCustomerName] = useState('');
  const [customerPhone, setCustomerPhone] = useState('');
  const [isAccountOpen, setIsAccountOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [alertMessage, setAlertMessage] = useState<string | null>(null);
  const initializeApp = async () => {
    let isguid = Cookies.get('guid');
    if (typeof isguid != 'string') {
      const req= new pb.guidReq();  
     
      req.setIp(window.location.hostname);
      catalogClient.getGuid(req, {}, (err, response) => {
        if (err) {
          console.error('Error fetching guid:', err.code, err.message);
        } else {
          Cookies.set('guid', response.getGuid());
        }
      });
    }
    const guid = Cookies.get('guid');
   
    };
  useEffect(() => {
    let isMounted = true;
    const fetchPage = async () => {
      setLoading(true);
      setError(null);
      let attempts = 0;
      const maxAttempts = 3;

      while (attempts < maxAttempts) {
        try {
 const response = await fetch(
  `https://cdn.yutongoriginal.ru/Site/hs/page/${encodeURIComponent(pagename)}`,
  {
    headers: {
      Accept: 'application/json',
    }
    // DO NOT put mode: 'no-cors' here
  }
);
          const text = await response.text();
          console.log(data);
          // Обработка ограничения запросов (как в вашем Rust-коде)
          if (text.includes('QUERY_LIMIT_EXCEEDED')) {
            attempts++;
            if (attempts < maxAttempts) {
              await new Promise((resolve) => setTimeout(resolve, 1200 * attempts));
              continue;
            } else {
              throw new Error('Превышен лимит запросов. Попробуйте позже.');
            }
          }

          const json: PageData = JSON.parse(text);

          if (isMounted) {
            setData(json);
            // Дополнительно устанавливаем title через document (на случай SSR)
            document.title = json.Title || 'Ютонг Оригинал';
          }
          break;
        } catch (err: any) {
          attempts++;
          if (attempts >= maxAttempts) {
            if (isMounted) {
              setError(err.message || 'Не удалось загрузить страницу');
            }
          } else {
            await new Promise((resolve) => setTimeout(resolve, 1000));
          }
        }
      }

      if (isMounted) setLoading(false);
    };

    if (pagename) fetchPage();

    return () => {
      isMounted = false;
    };
  }, [pagename]);

  if (loading) return <div className="loading">Загрузка страницы...</div>;
  if (error) return <div className="error">Ошибка: {error}</div>;
  if (!data) return <div className="not-found">Страница не найдена</div>;
 const updateQuantity = (porodId: number, quantity: number,storage:string) => {
          try {
            if (quantity === 0) {
              removeFromCart(porodId,storage)
              return
            }
            const guid = Cookies.get('guid');
            if (typeof guid === 'string') {
              const req = new pb.CartAddReq();
              req.setGuid(guid);
              req.setProductId(porodId);
              req.setQty(quantity);
              req.setStorage(storage);
              catalogClient.cartUpdate(req, {}, (err, response) => {
                if (err) {
                  console.error('Error adding to cart:', err.code, err.message);
                }
              });
            }
            setCartItems(prev => {
              const safeCartItems = prev || []
              return safeCartItems.map(item =>
                item.product.id === porodId  && item.storage === storage? { ...item, quantity,storage } : item
              )
            })
          } catch (error) {
            console.error('Error updating quantity:', error)
          }
        }
       
        const removeFromCart = (porodId: number,storage:string) => {
          try {
            const guid = Cookies.get('guid');
            if (typeof guid === 'string') {
            const req = new pb.CartRemoveReq();
            req.setGuid(guid);
            req.setProductId(porodId);
            req.setQty(0);
            req.setStorage(storage);
            catalogClient.cartRemove(req, {}, (err, response) => {
              
              if (err) {
                console.error('Error removing from cart:', err.code, err.message);
              }
            });
          }
            setCartItems(prev => {
              const safeCartItems = prev || []
              return safeCartItems.filter(item => !(item.product.id === porodId && item.storage === storage))
            })
          } catch (error) {
            console.error('Error removing from cart:', error)
          }
        }
        
          const setOrder = ()=>{
              if (!customerName || !customerPhone) {
                setAlertMessage(`Пожалуйста. Введите Ваше имя и номер телефона для связи`);
                return;
            }
          
              const guid = Cookies.get('guid');
              if (typeof guid === 'string') {
                const req=new pb.OrderAcceptReq();
                req.setGuid(guid);
                req.setName(customerName);
                req.setPhone(customerPhone);
                catalogClient.orderAccept(req, {}, (err, response) => {
                  if (err) {
                    console.error('Error removing from cart:', err.code, err.message);
                  } else {
                  if (response.getStatus()=="fail") { 
                    setAlertMessage(`${response.getMessage()}`);
                  } else {
                    setAlertMessage(`Спасибо за заказ.\n\ 
                      В ближайшее время наш менеджер свяжется с Вами.\n\ 
                      Номер вашего заказа: ${response.getNum()}`);
                    setCartItems([]);
                    setIsCartOpen(false);
                  }
                    return;
                  }
                });
              }
            }
          const OnsetIsInCartStorage=(items:string[])=>{
 
  }
  return (
    <div className="min-h-screen bg-gray-50">
      <Helmet>
        <title>{data.Title}</title>
        <meta name="description" content={data.Descript} />
        <meta property="og:title" content={data.Title} />
        <meta property="og:description" content={data.Descript} />
      </Helmet>
 
        <NewHeader
           cartItemCount={cartItemCount}
           onCartClick={() => setIsCartOpen(true)}
           onAccountClick={() => setIsAccountOpen(true)}
           searchQuery={searchQuery}
           onSearchChange={setSearchQuery}
           page='about'
         />
         <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto px-4 py-12">
          {parse(data.html || '')}
          </div>
          </div>
       <Footer/>
       {Array.isArray(cartItems) && (
                          <ShoppingCart
                            isOpen={isCartOpen}
                            onOpenChange={setIsCartOpen}
                            cartItems={cartItems}
                            onUpdateQuantity={updateQuantity}
                            onRemoveItem={removeFromCart}
                            onOrder={setOrder}
                            customerName={customerName}
                            customerPhone={customerPhone}
                            setCustomerName={setCustomerName}
                            setCustomerPhone={setCustomerPhone}
                            setCartItemCount={setCartItemCount}
                            setIsInCartStorage={OnsetIsInCartStorage}
                          />
                        )}
    </div>
  );
} 